import { CardModel } from '@/models/card.model';
import { ValidatorResult } from '@onrunning/backstage-models';
import { CrudService } from './crud.service';

export class CardsService {
  private crudService: CrudService<CardModel>;

  constructor() {
    this.crudService = new CrudService<CardModel>('cards');
  }

  public async getCards(pageId: string, accountId: string): Promise<ValidatorResult<CardModel[]>> {
    return await this.crudService.do('get', `${pageId}?accountId=${accountId}`, undefined, undefined, 'silent');
  }
}
